document.addEventListener("DOMContentLoaded", function () {
  const navLinks = document.querySelectorAll(".nav-link");
  const sections = document.querySelectorAll("[data-content]");

  // Function to update active nav link
  function updateActiveLink() {
    let current = "";

    sections.forEach((section) => {
      const sectionTop = section.getBoundingClientRect().top;
      const sectionHeight = section.offsetHeight;

      // Check if section is in viewport (with some offset)
      if (sectionTop <= 100 && sectionTop + sectionHeight > 100) {
        current = section.getAttribute("data-content");
      }
    });

    // Update nav links
    navLinks.forEach((link) => {
      const target = link.getAttribute("data-target");
      if (target === current) {
        link.classList.add("text-yellow");
        link.classList.remove("text-black");
      } else {
        link.classList.remove("text-yellow");
        link.classList.add("text-black");
      }
    });
  }

  // Initial call
  updateActiveLink();

  // Listen for scroll events
  window.addEventListener("scroll", updateActiveLink);

  // Smooth scrolling for nav links
  navLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href").substring(1);
      const targetSection = document.querySelector(
        `[data-content="${targetId}"]`
      );

      if (targetSection) {
        targetSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });
});
